<ng-container *ngIf="!('mobile' | mediaQuery)">
    <div [hidden]="!(sideNav.open$ | async)" class="tt-side-nav__menu">
        <a tabindex="-1" href="" (click)="filter = ''" class="tt-navbar__logo-wrapper">
            <img [src]="sideNav.logo$ | async" class="tt-navbar__logo" />
        </a>
        <div class="tt-side-nav__input-group">
            <span class="tt-side-nav__input-group--icon far fa-search"></span>
            <input #inputRef class="tt-side-nav__input" [(ngModel)]="filter" (ngModelChange)="rememberFilter($event)" (focus)="inputRef.select()" />
            <span [hidden]="!filter" class="tt-side-nav__input-group--icon tt-side-nav__input-group--icon-clear fal fa-times" (click)="filter = ''; $remember.next('')"></span>
        </div>

        <ul class="tt-side-nav__ul" tabindex="-1">
            <ng-container *ngFor="let menu of sideNav.rootSideNavItems$ | async | sideNavFilter: filter; trackBy: trackBy">
                <ng-container [ngSwitch]="'' + menu.item_id">
                    <tt-side-nav-item
                        *ngSwitchCase="'486'"
                        [ttId]="menu.item_id"
                        [ttText]="menu.item_name"
                        [ttIcon]="menu.item_glyphicon"
                        [ttIconColor]="menu.item_glyphicon_color"
                        [ttTabIndex]="!!filter ? '0' : '-1'"
                        (ttClick)="openFavouritesDialog(); afterClick()"
                    ></tt-side-nav-item>
                    <tt-side-nav-item
                        *ngSwitchDefault
                        [ttId]="menu.item_id"
                        [ttText]="menu.item_name"
                        [ttIcon]="menu.item_glyphicon"
                        [ttIconColor]="menu.item_glyphicon_color"
                        [ttGoto]="menu.item_state"
                        [ttGotoParms]="menu.item_parms"
                        (ttClick)="afterClick()"
                        [ttTabIndex]="!!filter ? '0' : '-1'"
                        [ttExpanded]="menu.expanded || !!filter"
                        (ttExpandedChange)="menu.expanded = $event; saveExpanded()"
                    >
                        <ng-container *ngIf="sideNav.open$ | async">
                            <tt-side-nav-item
                                *ngFor="let menu of sideNav.getChildren(menu.item_id, (sideNav.allSideNavItems$ | async) ?? []) | listFilter: filter; trackBy: trackBy"
                                [ttId]="menu.item_id"
                                [ttText]="menu.item_name"
                                [ttIcon]="!!menu.item_glyphicon?.trim() ? menu.item_glyphicon : 'far fa-arrow-right'"
                                [ttIconColor]="menu.item_glyphicon_color"
                                [ttGoto]="menu.item_state"
                                [ttGotoParms]="menu.item_parms"
                                (ttClick)="afterClick()"
                                [ttTabIndex]="menu.expanded || !!filter ? '0' : '-1'"
                            ></tt-side-nav-item>
                        </ng-container>
                    </tt-side-nav-item>
                </ng-container>
            </ng-container>
        </ul>

        <div class="tt-side-nav__user">
            <p class="tt-side-nav__user-info">
                <span class="tt-side-nav__user-name">
                    {{ sideNav.name$ | async }}
                </span>
                <span class="tt-side-nav__user-company">
                    {{ sideNav.company$ | async }}
                </span>
            </p>

            <tt-overflow-menu ttPosition="over" [ttFlipped]="!(sideNav.open$ | async)">
                <tt-overflow-menu-item
                    ttText="my_settings"
                    ttIcon="far fa-cog"
                    (ttClick)="state.go('usersettings', appSettings.settings.user?.portalUserKeynoEdit); afterClick()"
                ></tt-overflow-menu-item>
                <tt-overflow-menu-item style="width: 18rem; display: block" *ngIf="!!(graphAuth.account$ | async)" (ttClick)="graphAuth.signOut(); afterClick()" ttIcon="fab fa-microsoft" ttDanger>
                    <span style="flex: 1; display: flex; flex-direction: column; overflow: hidden">
                        <span style="width: 100%; overflow: hidden; text-overflow: ellipsis" ttTranslateWord="sign_out_microsoft"></span>
                        <span style="width: 100%; overflow: hidden; text-overflow: ellipsis; font-size: var(--tt-font-size-sm)">{{ (graphAuth.account$ | async)?.username }}</span>
                    </span>
                </tt-overflow-menu-item>
                <tt-overflow-menu-item *ngIf="!(graphAuth.account$ | async)" (ttClick)="graphAuth.signIn(); afterClick()" ttIcon="fab fa-microsoft" ttText="sign_in_microsoft"></tt-overflow-menu-item>
                <tt-overflow-menu-item ttHasDivider ttIcon="far fa-sign-out" ttText="sign_out" (ttClick)="state.signOut(); afterClick()" ttDanger></tt-overflow-menu-item>
            </tt-overflow-menu>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="'mobile' | mediaQuery">
    <div [hidden]="!(sideNav.open$ | async)" class="tt-side-nav__menu">
        <a tabindex="-1" href="" (click)="filter = ''" class="tt-navbar__logo-wrapper">
            <img [src]="sideNav.logo$ | async" class="tt-navbar__logo" />
        </a>
        <ul
            class="tt-side-nav__ul"
            tabindex="-1"
            (touchstart)="onMobileMenuTouchStart($event)"
            (touchmove)="onMobileMenuTouchMove($event)"
            (touchend)="onMobileMenuTouchEnd()"
            (touchcancel)="onMobileMenuTouchEnd()"
        >
            <ng-container *ngFor="let menu of sideNav.rootSideNavItems$ | async | sideNavFilter: filter; trackBy: trackBy">
                <ng-container [ngSwitch]="'' + menu.item_id">
                    <tt-side-nav-item
                        *ngSwitchCase="'486'"
                        [ttId]="menu.item_id"
                        [ttText]="menu.item_name"
                        [ttIcon]="menu.item_glyphicon"
                        [ttIconColor]="menu.item_glyphicon_color"
                        [ttTabIndex]="!!filter ? '0' : '-1'"
                        (ttClick)="openFavouritesDialog(); afterClick()"
                    ></tt-side-nav-item>
                    <tt-side-nav-item
                        *ngSwitchDefault
                        [ttId]="menu.item_id"
                        [ttText]="menu.item_name"
                        [ttIcon]="menu.item_glyphicon"
                        [ttIconColor]="menu.item_glyphicon_color"
                        [ttGoto]="menu.item_state"
                        [ttGotoParms]="menu.item_parms"
                        (ttClick)="afterClick()"
                        [ttTabIndex]="!!filter ? '0' : '-1'"
                        ttExpandable="false"
                    >
                    </tt-side-nav-item>
                </ng-container>
            </ng-container>
        </ul>

        <div class="tt-side-nav__user">
            <p class="tt-side-nav__user-info">
                <span class="tt-side-nav__user-name">
                    {{ sideNav.name$ | async }}
                </span>
                <span class="tt-side-nav__user-company">
                    {{ sideNav.company$ | async }}
                </span>
            </p>

            <tt-overflow-menu ttPosition="over" [ttFlipped]="!(sideNav.open$ | async)" ttMenuClasses="tt-side-nav__account-menu--mobile">
                <tt-overflow-menu-item
                    ttText="my_settings"
                    ttIcon="far fa-cog"
                    (ttClick)="state.go('usersettings', appSettings.settings.user?.portalUserKeynoEdit); afterClick()"
                ></tt-overflow-menu-item>
                <tt-overflow-menu-item style="width: 18rem; display: block" *ngIf="!!(graphAuth.account$ | async)" (ttClick)="graphAuth.signOut(); afterClick()" ttIcon="fab fa-microsoft" ttDanger>
                    <span style="flex: 1; display: flex; flex-direction: column; overflow: hidden">
                        <span style="width: 100%; overflow: hidden; text-overflow: ellipsis" ttTranslateWord="sign_out_microsoft"></span>
                        <span style="width: 100%; overflow: hidden; text-overflow: ellipsis; font-size: var(--tt-font-size-sm)">{{ (graphAuth.account$ | async)?.username }}</span>
                    </span>
                </tt-overflow-menu-item>
                <tt-overflow-menu-item *ngIf="!(graphAuth.account$ | async)" (ttClick)="graphAuth.signIn(); afterClick()" ttIcon="fab fa-microsoft" ttText="sign_in_microsoft"></tt-overflow-menu-item>
                <tt-overflow-menu-item ttHasDivider ttIcon="far fa-sign-out" ttText="sign_out" (ttClick)="state.signOut(); afterClick()" ttDanger></tt-overflow-menu-item>
            </tt-overflow-menu>
        </div>
    </div>
</ng-container>

<div class="tt-side-nav__content">
    <ng-content />
</div>

<span [ngClass]="{ 'tt-side-nav--open': (sideNav.open$ | async) }" class="tt-side-nav__mobile-overlay" (click)="sideNav.toggle()"></span>
<!-- <tt-side-drawer *ngIf="!('mobile' | mediaQuery)" #notifications ttPosition="end" ttInitialState="close" ttMode="over" ttOutsideClick (onOutsideClick)="notificationsOutsideClick(notifications)">
        TODO: notifcations here for easy access
    </tt-side-drawer> -->
<!-- </tt-side-drawer-container> -->
